<template>
  <b-modal :id="id" ref="online_edit"
           :ok-title="$t('booking.contactBBA')" @ok="submit" :ok-only="isOutdated"
           :cancel-title="$t('_cancel')" @cancel="submit"
  >
    <p class="display-list-bullet" v-html="text"></p>
  </b-modal>
</template>

<script>
export default {
  props: {
    booking: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      default: 'online_edit'
    },
    deadline: String
  },

  methods: {
    submit (event) {
      this.$emit('submit', {
        name: event.trigger === 'ok' ? 'confirm_edit' : event.trigger,
        booking: this.booking
      })
    }
  },

  computed: {
    isOutdated () {
      return this.deadline
        ? new Date(this.deadline) < new Date()
        : false
    },

    text () {
      return this.$t(`online.edit.${this.isOutdated ? 'outdated' : 'inTime'}`)
    }
  }
}
</script>
